var map = {
	"./background-faq.svg": 3460,
	"./background-forgot.svg": 4741,
	"./background-gadient.svg": 2700,
	"./background-login.svg": 5819,
	"./background-project-wizard.svg": 8905,
	"./background-project.svg": 2987,
	"./background-prompt.svg": 8102,
	"./background-set-password.svg": 8681,
	"./background-signup.svg": 1080,
	"./background-trial-ended.svg": 3759,
	"./base-logo.svg": 4748,
	"./brand24-logo.svg": 9828,
	"./carlsberg.svg": 5438,
	"./claude-icon.svg": 1485,
	"./deepseek-icon.svg": 6633,
	"./dot.svg": 484,
	"./empty-panel-dark.svg": 3884,
	"./empty-panel.svg": 5543,
	"./gemini-icon.svg": 5832,
	"./google-logo.svg": 3414,
	"./gradient-insights.svg": 2251,
	"./gradient-page.svg": 8637,
	"./gradient.svg": 7147,
	"./loder.svg": 6713,
	"./logo-sm.svg": 2035,
	"./mccann.svg": 979,
	"./openai-icon.svg": 3057,
	"./perplexity-icon.svg": 5473,
	"./samsung.svg": 5977,
	"./sheets-icon.svg": 7115,
	"./stanford.svg": 8520,
	"./uber.svg": 8671,
	"./viessmann-logo.svg": 443,
	"./wondery.svg": 5815,
	"./worksmile-logo.svg": 3136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6599;